import { render, staticRenderFns } from "./Khyjl.vue?vue&type=template&id=35cb350c&scoped=true"
import script from "./Khyjl.vue?vue&type=script&lang=js"
export * from "./Khyjl.vue?vue&type=script&lang=js"
import style0 from "./Khyjl.vue?vue&type=style&index=0&id=35cb350c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb350c",
  null
  
)

export default component.exports